import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { AddressMapper } from 'ish-core/models/address/address.mapper';
import { Address } from 'ish-core/models/address/address.model';
import { BasketInfoMapper } from 'ish-core/models/basket-info/basket-info.mapper';
import { BasketInfo } from 'ish-core/models/basket-info/basket-info.model';
import { BucketBaseData } from 'ish-core/models/bucket/bucket.interface';
import { ApiService } from 'ish-core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class CustomBasketService {
  constructor(private apiService: ApiService) {}

  private basketHeaders = new HttpHeaders({
    'content-type': 'application/json',
    Accept: 'application/vnd.intershop.basket.v1+json',
  });

  deleteBasket() {
    return this.apiService.currentBasketEndpoint().delete<BasketInfo[]>('', {
      headers: this.basketHeaders,
    });
  }

  updateBucketShippingMethod(
    bucketId: string,
    body: BucketBaseData
  ): Observable<{ bucket: BucketBaseData; infos: BasketInfo[] }> {
    return this.apiService
      .currentBasketEndpoint()
      .patch<{ data: BucketBaseData; infos: BasketInfo[] }>(`buckets/${bucketId}`, body, {
        headers: this.basketHeaders,
      })
      .pipe(
        map(payload => ({
          bucket: payload.data,
          infos: BasketInfoMapper.fromInfo({ infos: payload.infos }),
        }))
      );
  }
  getEligibleBasketAddresses(): Observable<Address[]> {
    return this.apiService
      .get<{ data: Address[] }>(`baskets/current/eligible-addresses`, {
        headers: this.basketHeaders,
      })
      .pipe(map(payload => payload.data.map(AddressMapper.fromData)));
  }
}
